/**
 * Template example output code
 * These examples show programmatic template structures for database templates
 */

/**
 * Get example output code for database templates
 */
export const getExampleOutputForTemplate = (templateId: string): string => {
  switch (templateId) {
    case 'preset-unity-static-typed':
      return `// Auto-generated Database (Folder Structure)
// This file is AUTO-GENERATED and can be safely regenerated.
// Access data like: Database.{{folderPath}}.{{itemName}}.{{fieldName}}
// Translation access: field["en"] or field["nl"]

namespace {{namespace}}
{
    public static class {{className}}
    {
{{#each folders}}
        public static class {{folderName}}
        {
{{#each subfolders}}
            public static class {{subfolderName}}
            {
{{#each items}}
                public static class {{itemName}}
                {
{{#each fields}}
                    public static readonly {{fieldType}} {{fieldName}} = {{fieldValue}};
{{/each}}
                }
{{/each}}
            }
{{/each}}
        }
{{/each}}
    }
}

// Example output:
// Database.scenes.player_house.bed.inspect_text
// For translatable fields: Database.scenes.player_house.bed.inspect_text["nl"]
// Separate TranslationKeys.cs file will be generated with translation data`;
    
    case 'preset-unity-runtime-database':
      return `// Auto-generated Runtime Content Database
// This file is AUTO-GENERATED and can be safely regenerated.
// Access data like: Database.Library["{{folderPath}}/{{itemName}}"]
// Translation access: field["en"] or field["nl"]

using System.Collections.Generic;

namespace {{namespace}}
{
    public static class {{className}}
    {
        #region Templates

        public abstract class Template { }

{{#each blueprints}}
        public sealed class {{blueprintName}} : Template
        {
{{#each fields}}
            public {{fieldType}} {{fieldName}};  // TranslationKey for translatable fields
{{/each}}
        }
{{/each}}

        #endregion

        public static readonly IReadOnlyDictionary<string, Template> Library = new Dictionary<string, Template>
        {
{{#each items}}
            ["{{folderPath}}/{{itemName}}"] = new {{blueprintName}}
            {
{{#each fields}}
                {{fieldName}} = {{fieldValue}},  // TranslationKeys.key_name for translatable fields
{{/each}}
            },
{{/each}}
        };
    }
}

// Example access:
// var item = (inspectable_object)Database.Library["scenes/player_house/bed"];
// var text = item.inspect_text["en"];  // Get English translation
// Separate TranslationKeys.cs file will be generated with translation data`;

    case 'preset-unity-id-records':
      return `// Auto-generated ID-based Records Database
// This file is AUTO-GENERATED and can be safely regenerated.
// Access data like: {{className}}.Get<{{RecordClassName}}>("{{itemId}}")
// Translation access: field["en"] or field["nl"]

using System.Collections.Generic;

namespace {{namespace}}
{
    public interface IRecord { }

{{#each blueprints}}
    public sealed class {{blueprintName}}Record : IRecord
    {
        public string Id;
{{#each fields}}
        public {{fieldType}} {{fieldName}};  // TranslationKey for translatable fields
{{/each}}
    }

{{/each}}
    public static class {{className}}
    {
        private static readonly Dictionary<string, IRecord> Records = new()
        {
{{#each items}}
            ["{{itemId}}"] = new {{blueprintName}}Record
            {
                Id = "{{itemId}}",
{{#each fields}}
                {{fieldName}} = {{fieldValue}},  // TranslationKeys.key_name for translatable fields
{{/each}}
            },
{{/each}}
        };

        public static T Get<T>(string id) where T : class, IRecord =>
            Records.TryGetValue(id, out var r) ? r as T : null;
    }
}

// Example access:
// var item = Db.Get<InspectableObjectRecord>("bed_player_house");
// var text = item.InspectText["en"];  // Get English translation for translatable fields
// Separate TranslationKeys.cs file will be generated with translation data`;

    case 'preset-roblox-static-typed':
      return `-- Auto-generated Database (Folder Structure)
-- This file is AUTO-GENERATED and can be safely regenerated.
-- Access data like: {{className}}.{{folderPath}}.{{itemName}}.{{fieldName}}

local {{className}} = {
{{#each folders}}
    {{folderName}} = {
{{#each subfolders}}
        {{subfolderName}} = {
{{#each items}}
            {{itemName}} = {
{{#each fields}}
                {{fieldName}} = {{fieldValue}},
{{/each}}
            },
{{/each}}
        },
{{/each}}
    },
{{/each}}
}

return {{className}}

-- Example output:
-- Database.scenes.player_house.bed.inspect_text`;

    case 'preset-roblox-database':
      return `-- Auto-generated Database (Category-based)
-- This file is AUTO-GENERATED and can be safely regenerated.
-- Access data like: {{className}}.{{categoryName}}["{{itemKey}}"].{{fieldName}}

local {{className}} = {
{{#each categories}}
    {{categoryName}} = {
{{#each items}}
        ["{{itemKey}}"] = {
{{#each fields}}
            {{fieldName}} = {{fieldValue}},
{{/each}}
        },
{{/each}}
    },
{{/each}}
}

return {{className}}

-- Example access:
-- Database.Quests["QUEST_001"].Name`;

    default:
      return '// No template structure available';
  }
};
